<template>
  <BaseLayout page-default-back-link="/nativeTab/news" pageTitle="提交认证资料">
    <ion-content class="certification-Fulfill">
      <div class="f-column f-y-center f-1 m-t-120">
        <img class="fulfill-image m-b-45" src="./assets/fulfill.png" alt />
        <div class="title m-b-20">恭喜您完成认证资料的提交</div>
        <div class="label m-b-10">请您耐心等待1个工作日时间，</div>
        <div class="label">认证结果会通过短信告知</div>
      </div>
    </ion-content>
  </BaseLayout>
</template>

<script>
import router from '@/router'
import * as yup from 'yup'
import { ref, reactive } from 'vue'
import { ProgressBar, Dialog } from '@/view/certification/components'
import formData from '@/view/certification/formData'
import { useRoute } from 'vue-router'
import { userApi } from '@/apis'

export default {
  setup() {
    if (window.webview) {
      window.webview.callHandler('request', userApi.infoUrl)
    }
    return {}
  },
  components: { ProgressBar },
}
</script>

<style lang="scss">
@import 'style.scss';

.certification-Fulfill {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
  .fulfill-image {
    width: 140px;
    height: 140px;
  }
  .title {
    font-size: 34px;
    font-weight: bold;
    color: #333333;
  }
  .label {
    font-size: 30px;
    color: #333333;
  }
}
</style>